import { observer } from "mobx-react";
import { StandardDialog } from "@roc/ui";
import { AppraisalReassignmentLetter } from "./appraisalReassignmentLetter";

export type AppraisalReassignmentLetterDialogProps = {
  open: boolean;
  loanId: any;
  propertyId: any;
  onClose: () => void;
}

export const AppraisalReassignmentLetterDialog = observer((props:AppraisalReassignmentLetterDialogProps)=>{
  const {open, loanId, propertyId, onClose} = props;
  return (
    <StandardDialog
      open = {open}
      title="Appraisal Reassignment Letter"
      maxWidth="xl"
      handleClose={onClose}
      dialogContent={
        <AppraisalReassignmentLetter
          loanId={loanId}
          propertyId={propertyId}
          onClose={onClose}
        />
      }
    />
  )
})